import type { LookContentEditorSection } from './types';

export const LOOK_CONTENT_EDITOR_METADATA_FIXED_ORDER: Array<LookContentEditorSection> = [
  'occasion',
  'look_name',
  'website',
];

export const LOOK_CONTENT_EDITOR_ENRICHMENT_SECTIONS: Array<LookContentEditorSection> = [
  'pdp',
  'visual_search',
  'search_seeds',
];

export const LOOK_CONTENT_EDITOR_STANDARD_ORDER: Array<LookContentEditorSection> = [
  'occasion',
  'website',
  'pdp',
];
